export const RECENT_CONTRACTS_PERM_CODE = 'RECENT_CONTRACTS_FEATURE';

export function formatRecentContractsMenuLabel(months) {
  const value = Number(months);
  return Number.isInteger(value) && value > 0
    ? `${value}개월 내 계약현황`
    : 'N개월 내 계약현황';
}

export function resolveMenuLabel(menu, months) {
  if (menu?.permCode !== RECENT_CONTRACTS_PERM_CODE) return menu?.label || '';
  return formatRecentContractsMenuLabel(months);
}
